import VueRouter from "vue-router";
import routes from "./routes";
import Vue from "vue";
import VueMeta from 'vue-meta';

const router = new VueRouter({
    routes,
    linkActiveClass: "active",
    mode: 'history'
});

Vue.use(VueRouter);
Vue.use(VueMeta);

export default router;
